import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import React from "react";

interface GlassButtonProps extends React.ComponentProps<typeof Button> {
  boxShadowColor?: string;
}

export const GlassButton = React.forwardRef<HTMLButtonElement, GlassButtonProps>((
  { className, boxShadowColor, style, ...props },
  ref
) => {
  const defaultStyle = {
    boxShadow: boxShadowColor
      ? `0 4px 16px ${boxShadowColor}, inset 0 1px 0 rgba(255,255,255,0.3)`
      : '0 2px 8px rgba(0,0,0,0.05), inset 0 1px 0 rgba(255,255,255,0.3)',
  };

  return (
    <Button
      className={cn(
        "bg-white/40 backdrop-blur-md border-white/30 hover:bg-white/50 shadow-sm transition-all duration-300",
        className
      )}
      style={{ ...defaultStyle, ...style }}
      ref={ref}
      {...props}
    />
  );
});

GlassButton.displayName = "GlassButton";
